import type { VariantProps } from '../tokens/variants';
import { cva } from '../tokens/variants';

export const headingVariants = cva(
  'text-[var(--tk-surface-fg)] font-semibold tracking-tight font-outfit',
  {
    variants: {
      size: {
        h1: 'text-4xl md:text-5xl leading-[1.1]',
        h2: 'text-3xl md:text-4xl leading-[1.15]',
        h3: 'text-2xl md:text-3xl leading-tight',
        h4: 'text-xl md:text-2xl leading-snug',
        h5: 'text-lg md:text-xl leading-snug',
        h6: 'text-base md:text-lg leading-snug',
      },
      color: {
        default: 'text-[var(--tk-surface-fg)]',
        muted: 'text-[var(--tk-surface-fg-muted)]',
        brand: 'text-[var(--tk-brand-fg-on-subtle)]',
        danger: 'text-[var(--tk-danger-fg-on-subtle)]',
      },
      align: {
        left: 'text-left',
        center: 'text-center',
        right: 'text-right',
      },
    },
    defaultVariants: { size: 'h2', color: 'default', align: 'left' },
  },
);

export type HeadingLevel = 1 | 2 | 3 | 4 | 5 | 6;

export const sizeToLevel: Record<NonNullable<VariantProps<typeof headingVariants>['size']>, HeadingLevel> = {
  h1: 1,
  h2: 2,
  h3: 3,
  h4: 4,
  h5: 5,
  h6: 6,
};
